<template>
  <div class="trial-complete">
    <div>
      <div class="title">
        <h4>完善您的账户信息</h4>
        <!-- <h3>可获产品360天免费使用权</h3>
        <p style="color: #aaa;">
          注：先获取180天免费时长，此期间累计使用需大于15天，才能自动获取剩余180天时长
        </p> -->
      </div>
      <user-form
        v-if="isGet"
        ref="userForm"
        class="trial-form"
        :user="user"
      ></user-form>
    </div>
  </div>
</template>
<script>
import UserForm from '@/components/UserForm'
import UserEnterpriseApi from '@/api/userEnterpriseApi.js'
import {
  message,
} from "ant-design-vue";
export default {
  name: 'Trial',
  components: {
    UserForm: UserForm
  },
  data () {
    return {
      isGet: false,
      user: null
    }
  },
  computed: {
    // globalId () {
    //   return this.$route.query.globalId
    // },
    // sgyToken () {
    //   return this.$route.query['sgy-token']
    // },
    // source () {
    //   return this.$route.query.source
    // }
  },
  created () {
    this.initUserInfo()
  },
  methods: {
    async initUserInfo () {
      this.isGet = false
      const res = await UserEnterpriseApi.getUserInfo()
      if (res.status) {
        const { data } = res
        this.user = data
        this.isGet = true
      } else {
        message.error(res.msg);
      }
    }
  }
}
</script>

<style scoped>
.trial-complete {
  min-height: calc(100vh - 102px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.title {
  text-align: center;
  margin: 20px auto;
}
.title h4 {
  font-size: 20px;
  font-weight: bold;
}
.trial-form {
  width: 450px;
  margin: auto;
}
.trial-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.trial-actions button {
  width: 300px;
  margin-bottom: 20px;
}
.start-trial-btn {
  width: 220px;
}
.user-type ::v-deep .ant-form-item-control-wrapper{
  text-align: left;
  top: -3px;
  padding-left: 15px;
}
</style>
